import { styled, Theme } from '@mui/material/styles';

import { Container } from '@mui/material';

export const ContainerStyled = styled(Container)(
  ({ theme }: { theme: Theme }) => {
    // margins make the landing pages look bad
    const margins = ['/', '/app/'].includes(window.location.pathname)
      ? {}
      : { marginTop: '60px', marginBottom: '90px' };
    return {
      ...margins,
      maxWidth: theme.breakpoints.values.xl,
    };
  },
);

export const Wrapper = styled('section')`
  display: flex;
  overflow-y: auto;
`;

export const SlidingContent = styled('section')`
  display: flex;
  flex-direction: column;
  min-height: 100vh;
  flex-grow: 1;
`;
